"use strict";

exports.__esModule = true;
exports.DashboardWidgetThumbnail = void 0;
var _react = _interopRequireWildcard(require("react"));
var _gridUtils = require("../Grid/gridUtils");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Thumbnail for DashboardWidget.
 */
var DashboardWidgetThumbnail = exports.DashboardWidgetThumbnail = /*#__PURE__*/function (_Component) {
  function DashboardWidgetThumbnail() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(DashboardWidgetThumbnail, _Component);
  var _proto = DashboardWidgetThumbnail.prototype;
  _proto.render = function render() {
    var _this = this;
    var _this$props = this.props,
      x = _this$props.x,
      y = _this$props.y,
      width = _this$props.width,
      height = _this$props.height,
      rowCount = _this$props.rowCount,
      columnCount = _this$props.columnCount,
      children = _this$props.children;
    var lines = [];
    var rowHeight = (0, _gridUtils.getGridRowHeight)(this.props);
    var columnWidth = (0, _gridUtils.getGridColumnWidth)(this.props);
    for (var rowIndex = 0; rowIndex < rowCount; rowIndex++) {
      lines.push(/*#__PURE__*/_react["default"].createElement("rect", {
        key: "row:" + rowIndex,
        fill: "rgba(0, 0, 0, 0.05)",
        x: 0,
        y: (rowIndex + 1) * rowHeight,
        width: width,
        height: 3
      }));
    }
    for (var columnIndex = 0; columnIndex < columnCount; columnIndex++) {
      lines.push(/*#__PURE__*/_react["default"].createElement("rect", {
        key: "column:" + columnIndex,
        fill: "rgba(0, 0, 0, 0.05)",
        x: (columnIndex + 1) * columnWidth,
        y: 0,
        width: 3,
        height: height
      }));
    }
    return /*#__PURE__*/_react["default"].createElement("svg", {
      x: x,
      y: y,
      width: width,
      height: height
    }, /*#__PURE__*/_react["default"].createElement("rect", {
      x: 0,
      y: y,
      width: width,
      height: height,
      fill: "#fff"
    }), lines, children.map(function (child, index) {
      return _this.renderChild(child, index);
    }));
  };
  _proto.renderChild = function renderChild(child, index) {
    var render = this.props.render;
    return render(Object.assign({}, child, {
      props: Object.assign({}, child.props, (0, _gridUtils.getGridCellDimensions)(this.props, child.props))
    }), index);
  };
  return DashboardWidgetThumbnail;
}(_react.Component);
DashboardWidgetThumbnail.defaultProps = {
  x: 0,
  y: 0,
  theme: undefined
};